import { createAsyncThunk } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetCakeToOrderCardsApiResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            slug: z.string(),
            name: z.string(),
            description: z.any().optional().nullable(),
            images: z.array(
                z.object({
                    url: z.string(),
                }),
            ).optional().nullable(),
        }),
    ),
});

type GetCakeToOrderCardsActionResponse
    = ApiResponse<z.infer<typeof GetCakeToOrderCardsApiResponseSchema>>
    | BaseError;

export const getCakeToOrderCards = createAsyncThunk<
    GetCakeToOrderCardsActionResponse
>(
    'SweetShopPageActionsGetCakeToOrderCards',
    async () => apiInstance.get(
        '/cake-to-orders',
        {
            'populate[images][fields][0]': 'url',
        },
        GetCakeToOrderCardsApiResponseSchema,
    ),
);
